import { useContext } from 'react'

import { NewsboardPostProfileContext } from '../../Newsboard.contexts'

export function useNewsboardPostProfileContext() {
  return useContext(NewsboardPostProfileContext)
}
